import { Action, createReducer, on } from '@ngrx/store';
import { CartResultLineItemSelection } from 'entities/cart-result';
import * as CartActions from '../cart/cart.actions';
import { MyCartState } from './my-cart-state';
import * as MyCartActions from './my-cart.actions';

export const initialState: MyCartState = {
  cartItems: [],
  fixedVendor: false,
  hotFlags: [],
  autoSelectQuote: false,
  inboundFreight: null,
  vendorPartsPriceResult: []
};

export const myCartReducer = createReducer<MyCartState, Action>(
  initialState,
  on(CartActions.selectOpenCart, (state, {autoSelectQuote}) => ({...state, autoSelectQuote: autoSelectQuote?? false})),
  on(MyCartActions.getCartDataSuccess, (state, {cartItems}) => {
    const existingCartItemsToUpdate = state.cartItems?.filter(eci => eci.selected);
    const updatedCartItems: any[] = cartItems?.map(incomingCartItem => {
      const selectedCartItem = existingCartItemsToUpdate.find(selectedItem => selectedItem.cartItemId === incomingCartItem.cartItemId);
      const selected = selectedCartItem?.selected;
      const inventory = selectedCartItem?.inventory;
      // If the incoming cart item does not have vendor info, retain the existing vendor info
      const vendorCode = incomingCartItem.vendorCode ?? selectedCartItem?.vendorCode;
      const vendorName = incomingCartItem.vendorName ?? selectedCartItem?.vendorName;
      const vendorBranchCode = incomingCartItem.vendorBranchCode ?? selectedCartItem?.vendorBranchCode;
      // Preserve locally-entered VIN, ESN, and CRC values
      const vin = selectedCartItem?.vin ?? incomingCartItem.vin;
      const esn = selectedCartItem?.esn ?? incomingCartItem.esn;
      const crc = selectedCartItem?.crc ?? incomingCartItem.crc;

      return ({...incomingCartItem, selected, inventory, vendorCode, vendorName, vendorBranchCode, vin, esn, crc});
    });
    const autoSelectQuote = updatedCartItems.length ? state.autoSelectQuote : false;
    return ({...state, cartItems: updatedCartItems || [], autoSelectQuote: autoSelectQuote });
  }),
  on(MyCartActions.selectAllItems, (state) => ({ ...state, cartItems: state.cartItems.map(x => ({...x, selected: true, branchCode: ''})) })),
  on(MyCartActions.unSelectAllItems, (state) => ({ ...state, cartItems: state.cartItems.map(x => ({...x, selected: false, branchCode: ''})) })),
  on(MyCartActions.getInventorySuccess, (state, { cartItemsWithInventory }: { cartItemsWithInventory: CartResultLineItemSelection[] }) =>
    ({
      ...state,
      cartItems: state.cartItems.map(cartItem => cartItemsWithInventory.find(ci => ci.cartItemId === cartItem.cartItemId) ?? cartItem)
    })
  ),
  on(MyCartActions.getHotFlagsSuccess, (state, {hotFlags}) => ({...state, hotFlags})),
  on(MyCartActions.getVendorPricesSuccess, (state, {cartItemsWithVendorPrices}) => ({
    ...state,
    cartItems: [...cartItemsWithVendorPrices, ...state.cartItems.filter(x => !x.selected)]
  })),
  on(MyCartActions.setVendorPartsPriceResult, (state, {vendorPartsPriceResult}) => ({
    ...state,
    vendorPartsPriceResult
  })),
  on(MyCartActions.searchVendorSuccess,
    (state, {partNumber, vendorCode, vendorName}) =>
      {
        const newItems = state.cartItems.map(cartItem => {
          if(cartItem.partNumber === partNumber){
            return {...cartItem, vendorCode, vendorName, isDefaultVendorSelected: cartItem.isDefaultVendorSelected == null? true: false};
          }
          return {...cartItem}
        });
        return ({...state, cartItems: [...newItems]});
      }),
  on(MyCartActions.toggleSelection, (state, {cartItemId}) => {
    return {...state, cartItems: state.cartItems.map(
      cartItem => {
        if(cartItem.cartItemId === cartItemId){
          return {...cartItem, selected: !cartItem.selected, branchCode: '' }
        } else {
          return {...cartItem, branchCode: '' }
        }
      }
    )};
  }),
  on(MyCartActions.updateBuyoutCartItem, (state, {cartItem}) => {
    return {...state, cartItems: state.cartItems.map(
      ci => {
        if(ci.cartItemId === cartItem.cartItemId){
          return {...ci, knownPartPrice: cartItem.knownPartPrice, knownPartBuyoutAmount: cartItem.knownPartBuyoutAmount }
        }
        return ci;
      }
    )};
  }),
  on(MyCartActions.updateCartItemHotFlag, (state, {cartItemId, hotFlagCode}) => {
    const cartItems = state.cartItems.map(x => {
      if(cartItemId === x.cartItemId){
        return {...x, hotFlagCode: hotFlagCode};
      }
      return x;
    });
    return ({...state, cartItems});
  }),
  on(MyCartActions.updateCartItemESN, (state, {cartItemId, esn}) => {
    const cartItems = state.cartItems.map(x => {
      if(cartItemId === x.cartItemId){
        return {...x, esn};
      }
      return x;
    });
    return ({...state, cartItems});
  }),
  on(MyCartActions.updateCartItemCRC, (state, {cartItemId, crc}) => {
    const cartItems = state.cartItems.map(x => {
      if(cartItemId === x.cartItemId){
        return {...x, crc};
      }
      return x;
    });
    return ({...state, cartItems});
  }),
  on(MyCartActions.updateCartItemVIN, (state, {cartItemId, vin}) => {
    const cartItems = state.cartItems.map(x => {
      if(cartItemId === x.cartItemId){
        return {...x, vin};
      }
      return x;
    });
    return ({...state, cartItems});
  }),
  on(CartActions.getFreightAndAddToCartSuccess, (state, {cart}) => ({...state, inboundFreight: cart.lineItems?.find(x => x.partNumber === "FREIGHT")}))
);
